import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "@/backend/Dashboard.vue";
import AdminLogin from "@/backend/AdminLogin.vue";
import Priority from "@/backend/components/priority/Priority.vue";
import Labels from "@/backend/components/labels/Labels.vue";
import Role from "@/backend/components/role/Role.vue";
import TeamMember from "@/backend/TeamMember.vue";
import Customers from "@/backend/components/Customers/index.vue"
import TicketListing from "../backend/components/Tickets/index.vue"
import TicketDetail from "../backend/components/Tickets/detail.vue"

import store from '../vuex/store.js'; 
import PageNotFound from "../pages/PageNotFound.vue"
const routes = [
    {
        name: "Dashboard",
        component: Dashboard,
        path: "/dashboard",
        meta: { requiresAuth: true }
    },
    {
        name: "DashboardMain",
        component: Dashboard,
        path: "/",
        meta: { requiresAuth: true }
    },
    {
        name: "AdminLogin",
        component: AdminLogin,
        path: "/login",
        meta: { requiresAuth: true }
    },
    {
        name: "Priority",
        component: Priority,
        path: "/priority",
        meta: { requiresAuth: true }
    },
    {
        name: "TeamMember",
        component: TeamMember,
        path: "/team-member",
        meta: { requiresAuth: true }
    },
    {
        name: "Customers",
        component: Customers,
        path: "/customers",
        meta: { requiresAuth: true }
    },
    {
        name: "TicketListing",
        component: TicketListing,
        path: "/tickets",
        meta: { requiresAuth: true }
    },
    {
        name: "TicketDetail",
        component: TicketDetail,
        path: "/tickets-detail/:ticketId?",
        meta: { requiresAuth: true }
    },
    {
        name: "Labels",
        component: Labels,
        path: "/labels",
        meta: { requiresAuth: true }
    },
    {
        name: "Role",
        component: Role,
        path: "/role",
        meta: { requiresAuth: true }
    },
    {
        path: "/:catchAll(.*)",
        name: "PageNotFound",
        component: PageNotFound
    },
]

let router = createRouter({
    history: createWebHistory(),
    mode: 'history',
    routes,
});


router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth == true) {
        next();
    } else {
        if(store.state.isAdmin == 2){
            next('/')       
        }else{
            next();
        }
    }
})

export default router;
